// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Educators_subtitleHighlight__zLHkb","article":"Educators_article__lHQiw","contactInfo":"Educators_contactInfo__QW513","articles":"Educators_articles__LvkgM"};